const TRANSLATABLE_METADATA_TEMPLATE_ATTRIBUTES_LIST = [
    "name",
    "headline",
    "subHeadline"
];
Object.freeze(TRANSLATABLE_METADATA_TEMPLATE_ATTRIBUTES_LIST);
export { TRANSLATABLE_METADATA_TEMPLATE_ATTRIBUTES_LIST };
